import { inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { DynamicDialogService } from '@common/ui/frontend-shared/dynamic-dialog';
import { getHelpMetadata, observeInnermostActivationEnd, takeWhileAlive } from '@core/frontend-shared';
import { DocumentationViewerComponent } from '../doc-viewer/doc-viewer.component';
import { VirtualDocName } from '../doc-viewer/virtual-docs';
import * as i0 from "@angular/core";
const DOC_INDEX_PATH = '';
// HelpButton tries to find the best matching documentation for current page.
// it will do so by checking routed components for @HelpDoc decorator.
export let DocumentationHelpButtonComponent = /*#__PURE__*/(() => {
  class DocumentationHelpButtonComponent {
    constructor() {
      this.dialogService = inject(DynamicDialogService);
      this.router = inject(Router);
      this.currentContextHelp = signal(null, ...(ngDevMode ? [{
        debugName: "currentContextHelp"
      }] : /* istanbul ignore next */[]));
      observeInnermostActivationEnd(this.router).pipe(takeWhileAlive()).subscribe(e => {
        const helpMetadata = this.findComponentHelpMetadataInActivatedRoute(e.snapshot);
        this.currentContextHelp.set(helpMetadata || null);
      });
    }
    findComponentHelpMetadataInActivatedRoute(route) {
      while (route) {
        if (route.component) {
          const helpMeta = getHelpMetadata(route.component);
          // console.log('check cmp',route.component, helpMeta)
          if (helpMeta) return helpMeta;
        }
        route = route.parent || null;
      }
      return null;
    }
    onClickButton() {
      const context = this.currentContextHelp();
      const documentPath = context?.docPath || VirtualDocName.NoContextHelpAvailable;
      this.dialogService.open(DocumentationViewerComponent, {
        data: {
          documentPath,
          noContextHelpFound: !documentPath
        },
        width: '90%',
        height: '85%',
        header: 'Hilfe',
        dismissableMask: true,
        padded: false
      });
    }
    static {
      this.ɵfac = function DocumentationHelpButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DocumentationHelpButtonComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: DocumentationHelpButtonComponent,
        selectors: [["documentation-help-button"]],
        features: [i0.ɵɵProvidersFeature([DynamicDialogService])],
        decls: 1,
        vars: 1,
        consts: [["type", "button", "uiButton", "", "icon", "question-circle", "label", "Hilfe", 1, "ui-button-grey", 3, "click", "rounded"]],
        template: function DocumentationHelpButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵlistener("click", function DocumentationHelpButtonComponent_Template_button_click_0_listener() {
              return ctx.onClickButton();
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("rounded", true);
          }
        },
        dependencies: [UiButtonComponent],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return DocumentationHelpButtonComponent;
})();